import React, { useContext } from 'react';
import { SideMenuItem } from './SideMenuItem';
import { SideMenuHeader } from './SideMenuHeader';
import { TenantContext } from '../../context/TenantContext';
import { urls } from '../../logic/urls';

import {
    DropdownItem
} from 'reactstrap';

export const MobileMenu = () => {

    const tenantContext = useContext(TenantContext);


    const AdministrationMenuRendered = <>
        <SideMenuHeader text="Administration" />
        <SideMenuItem text="Licensing" icon="file-alt" url={urls.license} />
        {/* <SideMenuItem text="Portal access" icon="key" url={urls.portalAccess} /> */}
        <SideMenuItem text="API Documentation" icon="plug" url={urls.apiDocumentation} />
    </>;

    const BasicMenuRendered = <>
        <SideMenuHeader text="Basic" />
        <SideMenuItem text="Global" icon="globe" url={urls.tenant} />
        <SideMenuItem text="Users" icon="user" url={urls.user}/>
        <SideMenuItem text="Contact Group" icon="users" url={urls.contactGroup}/>
        <SideMenuItem text="Device" icon="cogs" url={urls.device} />
    </>;

    return (
        <>
            {AdministrationMenuRendered}
            {BasicMenuRendered}
            <DropdownItem divider />
        </>
    )
}